import { openDB } from 'idb';
import { ElementParams, SopoDB, UserPermissions } from './indexedDbConfig';
import { notifyError } from '../components/snackbar/snackbar';
import { Dictionary } from '../helpers/dictionariesFromLayers';
import { KrEndangeredAreaFormTypes, KrLandslideFormTypes } from '../contexts/krFormContext';
import { poFormTypes } from '../contexts/poFormContext';
import { ObjectState } from '../containers/centralView/taskListView/types/tasklListViewProps';
import { TableSettings } from '../contexts/authContext';

const DB_VERSION = 16;

const dbPromise = openDB<SopoDB>('SopoDB', DB_VERSION, {
    upgrade(db, oldVersion) {
        if (oldVersion < 1) {
            db.createObjectStore("taskList");
            db.createObjectStore("loggedUser", {
                keyPath: 'name'
            });
            db.createObjectStore("userConfigs", {
                keyPath: 'username'
            });
        }
        if (oldVersion < 2) {
            db.deleteObjectStore("taskList");
            db.createObjectStore("taskList");
        }
        if (oldVersion < 3) {
            db.deleteObjectStore("taskList");
            db.createObjectStore("taskList");
            db.createObjectStore("dictionaries");
        }
        if (oldVersion < 4) {
            db.deleteObjectStore("taskList");
            db.createObjectStore("taskList");
        }
        if (oldVersion < 5) {
            db.deleteObjectStore("loggedUser");
            db.createObjectStore("loggedUser", {
                keyPath: 'name'
            });
        }
        if (oldVersion < 6) {
            db.deleteObjectStore("loggedUser");
            db.createObjectStore("loggedUser", {
                keyPath: 'name'
            });
        }
        if (oldVersion < 7) {
            db.deleteObjectStore("taskList");
            const taskList = db.createObjectStore("taskList");
            taskList.createIndex('user' as never, 'user', {
                unique: false, // Set to true if you want unique values.
            });
        }
        if (oldVersion < 8) {
            db.createObjectStore("userPermissions", {
                keyPath: 'name'
            });
        }
        if (oldVersion < 9) {
            db.deleteObjectStore("userConfigs");
            db.createObjectStore("userConfigs", {
                keyPath: 'username'
            });
        }
        if (oldVersion < 10) {
            db.deleteObjectStore("userConfigs");
            db.createObjectStore("userConfigs", {
                keyPath: 'username'
            });
        }
        if (oldVersion < 11) {
            db.deleteObjectStore("dictionaries");
            db.createObjectStore("dictionaries");
        }
        if (oldVersion < 12) {
            db.createObjectStore("tableWaitingRoomAliases");
        }
        if (oldVersion < 13) {
            const propositions = db.createObjectStore("dictPropositions");
            propositions.createIndex('user' as never, 'user', {
                unique: false, // Set to true if you want unique values.
            });
        }
        if (oldVersion < 14) {
            db.deleteObjectStore("dictPropositions");
            const propositions = db.createObjectStore("dictPropositions");
            propositions.createIndex('user' as never, 'user', {
                unique: false, // Set to true if you want unique values.
            });
        }
        if (oldVersion < 15) {
            db.createObjectStore("usersForMessages");
        }
        if (oldVersion < 16) {
            db.createObjectStore("codedValuesDictionaries");
        }
    }
})

export const setupDatabase = async () => {
    const db = await dbPromise;
    return db;
}

export async function getLoggedUser() {
    return (await dbPromise).get("loggedUser", `logged`);
}

export async function setLoggedUser(val: any) {
    return (await dbPromise).put("loggedUser", val);
}

export async function getTask(query: string, newStatus?: ObjectState | undefined) {
    if (newStatus) {
        await setTaskStatus(query, newStatus);
        return _getTask(query);
    } else {
        return _getTask(query);
    }
}

export async function _getTask(query: string) {
    var element = (await dbPromise).get("taskList", query);
    return element;
}

export async function deleteTask(query: string) {
    return (await dbPromise).delete("taskList", query);
}

export async function setTaskValidStatus(waitingRoomGlobalId?: string, validStatus?: string) {
    var element = structuredClone(await getTask(waitingRoomGlobalId!));
    if (element) {
        if (validStatus !== undefined) {
            var tableParams = structuredClone(element!.elementParams.tableParams);
            tableParams.WALIDACJA_DOM = validStatus;
            element!.elementParams.tableParams = tableParams;
        }
    }
    return (await dbPromise).put("taskList", element!, waitingRoomGlobalId);
}

export async function setTaskStatus(waitingRoomGlobalId?: string, Status?: string) {
    var element = structuredClone(await getTask(waitingRoomGlobalId!));
    if (element) {
        var tableParams = structuredClone(element!.elementParams.tableParams);
        tableParams.WALIDACJA_DOM = "niezwalidowana";
        if (Status !== undefined) {
            tableParams.STAN_OBIEKTU_DOM = Status;
        }
        element!.elementParams.tableParams = tableParams;
    }
    return (await dbPromise).put("taskList", element!, waitingRoomGlobalId);
}

export async function setTask(card: KrLandslideFormTypes | KrEndangeredAreaFormTypes | poFormTypes, status?: string, validation?: boolean,
    isPo?: boolean, isDefaultSave?: boolean, isCollective?: boolean) {
    var element = structuredClone(await getTask(card.waitingRoomGlobalId!));
    if (element) {
        element!.elementParams.card = card;
        var tableParams = structuredClone(element!.elementParams.tableParams);
        if (isCollective) {
            tableParams.WALIDACJA_DOM = "niezwalidowana";
        }
        else {
            if (isDefaultSave) {
            }
            else {
                if (!isPo) {
                    if (validation) {
                        tableParams.WALIDACJA_DOM = "pozytywna";
                    }
                    else {
                        tableParams.WALIDACJA_DOM = "negatywna";
                    }
                }
                else {
                    if (validation) {
                        tableParams.WALIDACJA_DOM = "pozytywna";
                    }
                    else {
                        tableParams.WALIDACJA_DOM = "negatywna";
                    }
                }
            }
        }
        if (status !== undefined) {
            tableParams.STAN_OBIEKTU_DOM = status;
        }
            element!.elementParams.tableParams = tableParams;
    }
    return (await dbPromise).put("taskList", element!, card.waitingRoomGlobalId);
}

export async function getTaskListFromDb() {
    var name: any = await getLoggedUser().then((value) => {
        return value?.val;
    });
    return (await dbPromise).getAllFromIndex("taskList", 'user' as never, name);
}

export async function getTaskListFromDbOfflineCheck(name: any) {
    return (await dbPromise).getAllFromIndex("taskList", 'user' as never, name);
}

export async function setTaskListInDb(taskList: ElementParams[], username: string) {
    const PromiseArray: Promise<any>[] = [];
    for (let i = 0; i < taskList.length; i++) {
        PromiseArray.push((await dbPromise).add("taskList", { elementParams: { tableParams: taskList[i].tableParams, card: taskList[i].card }, user: username }, taskList[i].card.waitingRoomGlobalId));
    }
    if (PromiseArray.length > 0) {
        return Promise.all(PromiseArray).then((response) => {
            return response;
        }).catch((error) => {
            notifyError({ message: "Błąd podczas pobierania kart: " + error });
        })
    }
    else {
        return undefined;
    }
}

export async function setDictProposition(username: string, proposition: any, type: string) {
    let element = {
        user: username,
        proposition: proposition,
        guid: crypto.randomUUID(),
        type: type
    }
    return (await dbPromise).put("dictPropositions", element, element.guid);
}

export async function getDictPropositions(username: any) {
    return (await dbPromise).getAllFromIndex("dictPropositions", 'user' as never, username);
}

export async function deleteDictPropositions(guid: string) {
    return (await dbPromise).delete("dictPropositions", guid);
}

export async function getUserConfig(username: string) {
    return (await dbPromise).get("userConfigs", username);
}

export async function getTableSettings(username: string, tableName: string) {
    let uConfig = await (await dbPromise).get("userConfigs", username);
    if (uConfig) {
        let tSetting = uConfig?.config?.tableSettings?.find(s => s.name === tableName);
        if (tSetting) {
            return tSetting;
        }
    }
    return {
        name: tableName,
        pageSize: 10
    }
}

export async function setUserConfigIdb(val: any) {
    return (await dbPromise).put("userConfigs", val);
}

export async function setTableSettings(username: string, settings: TableSettings) {
    let uConfig = await (await dbPromise).get("userConfigs", username);
    if (uConfig) {
        if (uConfig.config.tableSettings) {
            let tSettings = uConfig.config.tableSettings.filter(s => s.name !== settings.name);
            tSettings.push(settings);
            uConfig.config.tableSettings = tSettings;
        } else {
            uConfig.config.tableSettings = [settings];
        }
        return (await dbPromise).put("userConfigs", uConfig); 
    }
}

export async function getDictionaries(key: string) {
    return (await dbPromise).get("dictionaries", key);
}

export async function setDicts(dicts: Dictionary, key: string) {
    return (await dbPromise).put("dictionaries", dicts, key);
}

export async function getCodedValuesDictionaries() {
    return (await dbPromise).get("codedValuesDictionaries", "codedValues");
}

export async function setCodedValuesDictionaries(codedValues: Dictionary) {
    return (await dbPromise).put("codedValuesDictionaries", codedValues, "codedValues");
}

export async function getUsersForMessages() {
    return (await dbPromise).get("usersForMessages", "users");
}

export async function setUsersForMessages(users: any) {
    return (await dbPromise).put("usersForMessages", users, "users");
}

export async function getTableAliases(key: string) {
    return (await dbPromise).get("tableWaitingRoomAliases", key);
}

export async function setTableAliases(aliases: any, key: string) {
    return (await dbPromise).put("tableWaitingRoomAliases", aliases, key);
}

export async function getUserPermissionsIdb(name: string) {
    return (await dbPromise).get("userPermissions", name);
}

export async function setUserPermissionsIdb(val: UserPermissions) {
    return (await dbPromise).put("userPermissions", val);
}